import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { useHistory, useParams } from "react-router-dom";
import ParametrizacaoService from "../../services/ParametrizacaoService";
import { IParametro, IParametrizacaoRegras } from "../../interfaces/IParametro";
import EventoService from "../../services/EventoService";
import { IEvento } from "../../interfaces/IEvento";
import RegraService from "../../services/RegrasService";
import { IRegras } from "../../interfaces/IRegras";

function ParametrizacaoModal() {

    const intl = useIntl();
    const history = useHistory();
    const { classes } = useLayout();
    const { id } = useParams<{ id: string }>();
    const [parametro, setParametro] = useState<IParametro>({} as IParametro);
    const [pesquisaEventos, setPesquisaEventos] = useState<string>('');
    const [pesquisaRegras, setPesquisaRegras] = useState<string>('');
    const [eventosDisponiveis, setEventosDisponiveis] = useState<IEvento[]>([]);
    const [eventosVisualizados, setEventosVisualizados] = useState<IEvento[]>([]);
    const [regrasDisponiveis, setRegrasDisponiveis] = useState<IRegras[]>([]);
    const [regrasVisualizadas, setRegrasVisualizadas] = useState<IRegras[]>([]);
    const [regraDisponivelSelecionada, setRegraDisponivelSelecionada] = useState<IRegras>();
    const [regrasAdicionadas, setRegrasAdicionadas] = useState<IRegras[]>([]);
    const [regraAdicionadaSelecionada, setRegraAdicionadaSelecionada] = useState<IRegras>();
    const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
    const [eventoSelecionado, setEventoSelecionado] = useState<IEvento>();
    const parametrizacaoBreadCrumbs: Array<PageLink> = [
      {
        title: 'Parametrizações',
        path: '/parametrizacoes',
        isSeparator: false,
        isActive: false
      },
      {
        title: '',
        path: '',
        isSeparator: true,
        isActive: true
      }
    ];

    useEffect(() => {
      async function preCarregar() {
        
        setRegrasAdicionadas([]);
        setRegraDisponivelSelecionada(undefined);
        setRegraAdicionadaSelecionada(undefined);

        await RegraService.obterTodos(async x => {
          if (id) {
            await ParametrizacaoService.obterPorId(parseInt(id), c => {
              const rulesAdded = c.parametrizacaoRegras?.map(p => p.regra) ?? [];
              const regras = x.filter(p => !rulesAdded.some(z => z.id === p.id));

              setParametro(c);
              setRegrasDisponiveis(regras);
              setRegrasVisualizadas(regras);
              setEventoSelecionado(c.evento);
              setRegrasAdicionadas(rulesAdded);
            });
          } else {
            setRegrasDisponiveis(x);
            setRegrasVisualizadas(x);
          }
        });

        await EventoService.obterTodos(x => {
          setEventosDisponiveis(x);
          setEventosVisualizados(x);
        });

        setPaginaCarregada(true);
      }

      setTimeout(() => {
        preCarregar();
      }, 1000)

    //eslint-disable-next-line
    }, []);

    useEffect(() => {
      if (pesquisaEventos === '' || pesquisaEventos === null) {
        setEventosVisualizados(eventosDisponiveis);

        return;
      }

      const eventosPesquisados = eventosDisponiveis.filter(e => e.nome.toLowerCase().indexOf(pesquisaEventos.toLowerCase()) >= 0);

      setEventosVisualizados(eventosPesquisados);

  //eslint-disable-next-line
  }, [pesquisaEventos]);

  useEffect(() => {
    if (pesquisaRegras === '' || pesquisaRegras === null) {
      setRegrasVisualizadas(regrasDisponiveis);

      return;
    }

    const regrasPesquisadas = regrasDisponiveis.filter(e => (e.nome ?? "").toLowerCase().indexOf(pesquisaRegras.toLowerCase()) >= 0);

    setRegrasVisualizadas(regrasPesquisadas);

  //eslint-disable-next-line
  }, [pesquisaRegras]);

  async function salvar() {
    const parametroTemporario = parametro;

    parametroTemporario.parametrizacaoRegras = regrasAdicionadas?.map(x => {
      const valor: IParametrizacaoRegras = { 
          parametrizacaoID: parametro.id,
          regraID: x.id,
          regra: x
        };

        return valor;
    });
    parametroTemporario.eventoID = eventoSelecionado?.id;
    parametroTemporario.evento = eventoSelecionado;

    setParametro(parametroTemporario);

    if (id ===  undefined) {
      await ParametrizacaoService.criar(parametro, () => history.push("/parametrizacoes"), 'Parâmetro adicionado com sucesso');
    } else {
      await ParametrizacaoService.atualizar(parametro, () => history.push("/parametrizacoes"), 'Parâmetro editado com sucesso');
    }
  }

  return <>
    <PageTitle pageBack="/parametrizacoes" breadcrumbs={parametrizacaoBreadCrumbs}>{intl.formatMessage({ id: 'MENU.NEW_PARAMETERIZATION' })}</PageTitle>
    <div className='toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
            <DefaultTitle />
            <div className='d-flex align-items-center py-1'>
                <button onClick={salvar} className='btn btn-sm btn-primario'>
                    <i className="text-white far fa-save"/>
                    <span style={{ verticalAlign: 'middle' }}> SALVAR </span>
                </button>
            </div>
        </div>
    </div>
    {
      paginaCarregada ?
        <>
          <div className="row">
            <div className="col-md-4 mb-4">
              <label htmlFor="nome" className="form-label">Nome do Parâmetro</label>
              <input value={parametro.nome ?? ""} onChange={e => setParametro({...parametro, nome: e.target.value})} placeholder="Nome" type="text" className="form-control" id="nome" />
            </div>
          </div>
          <div className="row mt-3" style={{ height: '80%' }}>
              <div className="col-md-2" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px' }}>
                  <h1 className="azul-agriholmes  mt-5 mb-5">Eventos</h1>
                  <div style={{border: '1px solid #DDD', borderRadius: '10px', padding: '8px 5px', height: '35px' }}>
                    <i className="bi bi-search" />
                    <input onChange={e => setPesquisaEventos(e.target.value)} placeholder="Buscar" style={{ backgroundColor: 'white', border: 'none', outline: 'none', paddingLeft: '5px', width: '89%' }}/>
                  </div>
                  <div>
                      {
                        eventosVisualizados?.map((x, index) =>
                          <div key={index} className="mt-5 mb-5">
                            <input onChange={() => {
                              setEventoSelecionado(x)
                              setParametro({...parametro, evento: x});
                            }} checked={x.id === eventoSelecionado?.id} className="form-check-input form-check-input-azul" type="radio" name="radio-evento" value={x.id}  id={`evento-${x.id}`} />
                            <label className="form-check-label" htmlFor={`evento-${x.id}`} style={{ width: '80%' }}>
                              {x.nome}
                            </label>
                          </div>
                        )
                      }
                      {
                        eventosVisualizados?.length === 0 && <p>Nenhum evento localizado</p>
                      }
                  </div>
              </div>
              <div className="col-md-2 ms-5" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px', padding: '0' }}>
                <h1 className="azul-agriholmes mt-5 mb-5 padding-regras-adicionadas">Regras Adicionadas</h1>
                {
                  regrasAdicionadas?.sort((a, b) =>  ((a.nome ?? "") > (b.nome ?? "") ? 1 : -1)).map((x, index) =>
                    <p key={index} onClick={() => {
                        if (regraAdicionadaSelecionada?.id === x.id) {
                          setRegraAdicionadaSelecionada(undefined);

                          return;
                        }

                        setRegraAdicionadaSelecionada(x);
                        setRegraDisponivelSelecionada(undefined);
                    }} className={`parametrizacao-item ${regraAdicionadaSelecionada?.id === x.id ? 'parametrizacao-item-selecionado' : ''}`}>{x.nome}</p>
                  )
                }
              </div>
              <div className="col-md-1 align-items-center ms-1 mx-1" style={{ padding: '0', margin: '0', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                  <div className='align-items-center py-1'>
                      <button disabled={regraDisponivelSelecionada === null || regraDisponivelSelecionada === undefined} onClick={() => {
                        if (regraDisponivelSelecionada !== undefined){
                          setRegrasAdicionadas([...regrasAdicionadas, regraDisponivelSelecionada]);
                          setRegrasVisualizadas(regrasVisualizadas?.filter(x => x !== regraDisponivelSelecionada));
                          setRegraDisponivelSelecionada(undefined);
                        }
                      }} className='btn btn-sm btn-primario'>
                        <i className="text-white fa fa-arrow-left"/>
                      </button>
                  </div>
                  <div className='align-items-center py-1'>
                      <button disabled={regraAdicionadaSelecionada === null || regraAdicionadaSelecionada === undefined} onClick={() => {
                        if (regraAdicionadaSelecionada !== undefined){
                          setRegrasVisualizadas([...regrasVisualizadas, regraAdicionadaSelecionada]);
                          setRegrasAdicionadas(regrasAdicionadas?.filter(x => x !== regraAdicionadaSelecionada));
                          setRegraAdicionadaSelecionada(undefined);
                        }
                      }} className='btn btn-sm btn-primario'>
                        <i className="text-white fa fa-arrow-right"/>
                      </button>
                  </div>
              </div>
              <div className="col-md-6" style={{ padding: '0', border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px', height: '95%' }}>
                  <div style={{ display: 'flex' }}>
                    <h1 className="azul-agriholmes mt-5 mb-5 padding-regras-adicionadas">Lista de Regras</h1>
                    <div style={{border: '1px solid #DDD', borderRadius: '10px', padding: '8px 5px', margin: '10px 10px 0 auto', height: '35px' }}>
                      <i className="bi bi-search" />
                      <input onChange={e => setPesquisaRegras(e.target.value)} placeholder="Buscar" style={{ backgroundColor: 'white', border: 'none', outline: 'none', paddingLeft: '5px' }}/>
                    </div>
                  </div>
                  {
                    regrasVisualizadas !== null && regrasVisualizadas !== undefined && regrasVisualizadas.length > 0
                    ?
                    regrasVisualizadas.sort((a, b) =>  ((a.nome ?? "") > (b.nome ?? "") ? 1 : -1)).map((x, index) =>
                      <p key={index} onClick={() => {

                          if (regraDisponivelSelecionada?.id === x.id) {
                            setRegraDisponivelSelecionada(undefined);

                            return;
                          }

                          setRegraDisponivelSelecionada(x);
                          setRegraAdicionadaSelecionada(undefined);
                      }} className={`parametrizacao-item ${regraDisponivelSelecionada?.id === x.id ? 'parametrizacao-item-selecionado' : ''}`}>{x.nome}</p>
                    )
                    : 
                    <h1 className="mt-5 ms-5">Não foi encontrada nenhuma regra</h1>
                  }
              </div>
          </div>
        </>
      : <p>Carregando...</p>
    }
  </>
}

export default ParametrizacaoModal;